module.exports = __webpack_public_path__ + "img/block9-left.174f6f80.jpg";